// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-1M9-O","info":"info-2GowL","copy":"copy-3scBa"};